module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/456.248715dc.png";